import { Transaction, VersionedTransaction } from '@solana/web3.js'

/**
 * Serializes a transaction to bytes for signing.
 * Legacy transactions are serialized without requiring all signatures so they
 * can be passed to a remote signer before all co-signers have signed.
 */
export function serializeForSigning(tx: Transaction | VersionedTransaction): Uint8Array {
	if (tx instanceof VersionedTransaction) return tx.serialize()
	return tx.serialize({ requireAllSignatures: false, verifySignatures: false })
}

/**
 * Reconstructs a fully-signed transaction of the same type as `original` from
 * the raw bytes returned by a remote signer.
 */
export function deserializeSignedTransaction<T extends Transaction | VersionedTransaction>(
	original: T,
	signedBytes: Uint8Array
): T {
	if (original instanceof VersionedTransaction) {
		return VersionedTransaction.deserialize(signedBytes) as T
	}
	return Transaction.from(signedBytes) as T
}
